import { useEffect } from 'react';
import { useDocument } from '@nandorojo/swr-firestore';
import { ISoundEffect } from '@typings/setting/soundEffect.interface';
import { SettingCollectionPath } from '@typings/collections.enum';
import { useAudioPlayer } from './useAudioPlayer';

export function useGlobalClickSound() {
  const { data: soundEffect } = useDocument<ISoundEffect>(
    SettingCollectionPath.SOUNDEFFECT,
    { listen: true },
  );

  const { play } = useAudioPlayer(
    {
      default: soundEffect?.buttonSound?.url,
      menu: soundEffect?.listSound?.url,
      card: soundEffect?.cardSound?.url,
    },
    Number(soundEffect?.volume) || 0.3,
  );

  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      if (!soundEffect?.isActive) return;

      const target = e.target as HTMLElement;
      const soundType = target
        .closest('[data-sound-type]')
        ?.getAttribute('data-sound-type') as 'menu' | 'card';

      switch (soundType) {
        case 'menu':
          play('menu');
          break;
        case 'card':
          play('card');
          break;
        default:
          play('default');
      }
    };

    window.addEventListener('click', handleClick);
    return () => window.removeEventListener('click', handleClick);
  }, [soundEffect?.isActive, play]);
}
